module.exports = __webpack_public_path__ + "img/dashboard.09fb3b98.jpg";